export default __webpack_public_path__ + "static/media/apple_stimuli_es_phone.98d0f9bc.mp4";